import { useCreateTeamMutation, useGetEmployeesQuery, useGetTeamQuery, useUpdateTeamMutation } from '../../../../api/plamo-api'
import { Breadcrumb, Form, Row } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'

import { HomeOutlined } from '@ant-design/icons';
import { useCallback, useMemo } from 'react';

import { IconGearSolid, IconPeopleGroupSolid } from '../../../../icon';
import { AdvancedForm } from '../../form/advanced-form';
import FormItem from '../../form/form-item';

function TeamDetailsPage() {
  const { id } = useParams();
  const teamId = useMemo(() => parseInt(id || "") || undefined, [id])
  const { data: team } = useGetTeamQuery({ id }, { skip: id === 'new' }) as { data: any }
  const { data: teamMembers } = useGetEmployeesQuery({ f: JSON.stringify({ "team.id": { c: "EQ", v: parseInt(id || '0') } })}, { skip: id === 'new' }) as { data: any }
  const teamLead = useMemo(() => teamMembers?.items?.find(t => t.teamLead), [teamMembers?.items])
  const [form] = Form.useForm();
  const [createTeam, { isLoading: isCreatingTeam }] = useCreateTeamMutation();
  const [updateTeam, { isLoading: isUpdatingTeam }] = useUpdateTeamMutation();
  
  const navigate = useNavigate();

  const isLoading = isCreatingTeam || isUpdatingTeam;

  const onFinish = useCallback(async (values: any) => {
    if(!teamId) {
      const { data: newTeam }:any = await createTeam(values);
      console.log("Created new employee", newTeam);
      navigate(`./../${newTeam.id}`)
    } else {
      const newTeam = {...team, ...values}
      await updateTeam(newTeam);
    }
  }, [teamId, createTeam, updateTeam, navigate, team]);

  const combinedValues = useMemo(() => ({...team, teamMembers: teamMembers?.items?.map(t => t.id), teamLead: teamLead?.id }), [team, teamMembers, teamLead]);

  return (
    <div  style={{ height: "100%", overflow: "scroll", display: 'flex', flexDirection: 'column' }}>
       <Breadcrumb
          style={{ marginBottom: "24px" }}
          items={[
            {
              onClick: () => navigate('/'),
              title: <HomeOutlined />,
            },
            {
              title: (
                <>
                  <IconGearSolid />
                  <span>Einstellungen</span>
                </>
              ),
            },  
            {
              title: (
                <>
                  <IconPeopleGroupSolid /> Teams
                </>
              )
            },            
          ]}
        />
      
      <AdvancedForm form={form} name="customer" onFinish={onFinish} isLoading={isLoading} originalValues={combinedValues} initialEditing={!teamId}>
        <Row><h3>Team-Einstellungen</h3></Row>
        <Row gutter={24}>
          <FormItem fieldName="name" label="Name" />
          <FormItem fieldName="teamMembers" label="Mitglieder" type="ref" typeData={{ query: useGetEmployeesQuery, getId: employee => employee.id, render: employee => `${employee.firstName} ${employee.lastName}`, multiple: true }}/>
          <FormItem fieldName="teamLead" label="Teamleitung" type="ref" typeData={{ query: useGetEmployeesQuery, getId: employee => employee.id, render: employee => `${employee.firstName} ${employee.lastName}` }}/>
        </Row>
      </AdvancedForm>
    </div>
  )
}

export default TeamDetailsPage